export const BUSINESS_TIMEZONE =
  process.env.REACT_APP_BUSINESS_TIMEZONE ?? 'America/Argentina/Buenos_Aires'
